var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"learnworlds-main-text learnworlds-main-text-small learnworlds-element"},[_vm._v("\n    "+_vm._s(_vm.copyrightLabel)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }